export default function ldjson(content) {
  return <script
    type='application/ld+json'
    dangerouslySetInnerHTML={ { __html: JSON.stringify(content) } }
  />
}
